import { CircularProgress } from "@chakra-ui/react";
import styled from "@emotion/styled";
import {
  collection,
  query,
  orderBy,
  limit,
  onSnapshot,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "../../components/common/Breadcrumb";
import { db } from "../../firebaseConfig";
import CardWithImg from "./Card";

const MainBlogPage = () => {
  const [data, setData] = useState([]);
  const [showSpinner, setShowSpinner] = useState(false);
  useEffect(() => {
    setShowSpinner(true);
    const articleRef = collection(db, "Blog");
    const q = query(articleRef, orderBy("createdAt", "desc"), limit(10));
    onSnapshot(q, (snapshot: any) => {
      const blog = snapshot.docs.map((doc: any) => ({
        ...doc.data(),
        id: doc.id,
      }));
      setData(blog);
      setShowSpinner(false);
    });
  }, []);


  const bredData = [
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Blog",
      link: "/blog",
      active: true,
    },
  ];
  return (
    <Div>
      {showSpinner && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <CircularProgress isIndeterminate color="#f75d34" />
        </div>
      )}
      <div className="hero-section-card">
        <div className="back-change">
          <div>
            <h1>
              Our Latest <span style={{ color: "#ff5733" }}>News</span>
            </h1>
            <p>Know more to choose better</p>
          </div>
        </div>
      </div>
      <div className="main-content">
        <Breadcrumb bredData={bredData} />
        <div className="main-content-wrapper">
          <div className="card-container">
            {data.map((blog) => (
              <>
                <CardWithImg data={blog}/>
              </>
            ))}
          </div>
          <div className="recent-post-container">
            <h2 className="rec-header">Recent Posts</h2>
            <div className="recent-card">
              <div className="img-wrapper">
                <img
                  src="https://www.digitaltrends.com/wp-content/uploads/2022/10/iphone-14-pro-max-hero-photo.jpg?p=1"
                  alt=""
                />
              </div>
              <div style={{ marginLeft: "1rem" }}>
                <h2 style={{ fontWeight: "bold" }}>iPhone 14 Pro Max</h2>
                <div className="read-more">
                  <Link to={"blog/1"}>Read more</Link>
                </div>
              </div>
            </div>
            <hr />
            <div className="recent-card">
              <div className="img-wrapper">
                <img
                  src="https://www.digitaltrends.com/wp-content/uploads/2022/10/iphone-14-pro-max-hero-photo.jpg?p=1"
                  alt=""
                />
              </div>
              <div style={{ marginLeft: "1rem" }}>
                <h2 style={{ fontWeight: "bold" }}>iPhone 14 Pro Max</h2>
                <div className="read-more">
                  <Link to={"blog/1"}>Read more</Link>
                </div>
              </div>
            </div>
            <hr />
            <div className="real-all">
              <a href="#">Read All Posts </a>
            </div>
          </div>
        </div>
      </div>
    </Div>
  );
};

export default MainBlogPage;

const Div = styled.div`
  .main-content {
    padding: 5%;
    padding-top: 2rem;
  }
  .main-content-wrapper {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .card-container {
    display: flex;
    justify-content: space-evenly;
    flex-wrap: wrap;
    width: 75%;
  }
  .card-con {
    cursor: pointer;
    transition: 0.5s ease;
  }
  .card-con:hover {
    border: 2px solid #ff5733;
    .img-card {
      -webkit-transform: scale(1.2);
      -ms-transform: scale(1.2);
      transform: scale(1.2);
      transition: 0.5s ease;
    }
  }
  .img-card {
    transition: 1s ease;
    overflow: hidden;
  }
  .back-change {
    background-color: #0f141e78;
    transition: background 0.3s, border-radius 0.3s, opacity 0.6s;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    h1 {
      color: #ffffff;
      font-size: 55px;
      line-height: 51px;
      text-align: center;
      font-weight: bolder;
    }
    p {
      text-align: center;
      color: #dcdcdc;
      font-size: 18px;
    }
  }
  .recent-post-container {
    /* border-left: 1px solid red; */
    width: 25%;
    padding: 10px;
  }
  .rec-header {
    font-size: 21px;
    font-weight: 600;
    line-height: 26px;
    text-align: center;
    margin-top: 1rem;
    margin-bottom: 3rem;
  }
  .recent-card {
    display: flex;
    flex-wrap: wrap;
    box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
    width: 100%;
    height: 100px;
    padding: 10px;
    padding-right: 40px;
    margin-bottom: 1rem;
    margin-top: 1rem;
    .img-wrapper {
      width: 80px;
      height: 80px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
    }
    .read-more {
      text-decoration: underline;
      color: #ff5733;
      margin-top: 1rem;
    }
  }
  .real-all {
    margin-top: 1rem;
    text-decoration: underline;
    color: #ff5733;
    font-weight: 500;
  }
  @media only screen and (max-width: 600px) {
    .card-container {
      width: 100%;
    }
    .recent-post-container {
      width: 100%;
    }
  }
`;
